module.exports = __webpack_public_path__ + "static/media/ye.34d9d95f.svg";